module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.notFound) ? [_c('not-found')] : [(_vm.loading) ? _c('loading') : [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), (!_vm.error) ? [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "text-center campaign-name"
  }, [_vm._v(_vm._s(_vm.campaign.name))]), _c('h4', {
    staticClass: "text-center saved-campaign"
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.saved-campaign')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('full-info-box', {
    attrs: {
      "campaign": _vm.campaign,
      "configuration": "proposal.infobox"
    }
  })], 1), _c('div', {
    staticClass: "col-md-6 right-info-box"
  }, [_c('send-email', {
    attrs: {
      "campaign": _vm.campaign,
      "send_campaign_summary": _vm.send_campaign_summary
    }
  }), (_vm.feature_duplicate_draft) ? _c('duplicate-draft', {
    attrs: {
      "campaign": _vm.campaign
    }
  }) : _vm._e(), _c('edit-campaign', {
    attrs: {
      "campaign": _vm.campaign
    }
  })], 1)])])] : _vm._e()]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-429cbe31"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposal/Proposal.vue
// module id = 927
// module chunks = 1